import { combineReducers } from 'redux';
import authReducer from './authReducer';
import accommodationsReducer from './accommodationsReducer';
import filtersReducer from './filtersReducer';
import toursReducer from './toursReducer';
import ownersReducer from './ownersReducer';
import commonReducer from './commonReducer';
import errorReducer from './errorReducer';

/**
 * TODO: Renombrar los reducers y actualizar los apuntadores de toda la app
 * */

export default combineReducers({
    authReducer,
    accommodation: accommodationsReducer,
    toursReducer,
    filtersReducer,
    ownersReducer,
    commonReducer,
    errors: errorReducer
});


// WEBPACK FOOTER //
// ./src/reducers/index.js